<template>
  <nav :class="classes" class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <div class="navbar-wrapper" v-if="logo">
        <a class="navbar-brand">
          <div class="client-image__wrapper">
            <img class="client-image" :src="logo" alt="Client logo">
          </div>
        </a>
      </div>
      <slot></slot>
      <button class="navbar-toggler collapsed"
              type="button"
              @click.stop="onToggle"
              data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>

      <CollapseTransition>
        <div class="collapse navbar-collapse justify-content-end show"
             :class="navbarMenuClasses"
             v-show="showNavbar"
             id="navigation">
          <ul class="navbar-nav" v-click-outside="hideNavbar">
            <slot name="navbar-menu"></slot>
          </ul>
        </div>
      </CollapseTransition>
    </div>
  </nav>
</template>
<script>
  import {CollapseTransition} from 'vue2-transitions';

  export default {
    name: 'navbar',
    props: {
      showNavbar: {
        type: Boolean,
        description: "Whether navbar is visible"
      },
      navbarMenuClasses: {
        type: [String, Object],
        description: 'Navbar menu css classes'
      },
      transparent: {
        type: Boolean,
        default: true,
        description: 'Whether navbar is transparent'
      },
      position: {
        type: String,
        default: 'absolute',
        description: 'Navbar position (absolute|fixed|relative)'
      },
      type: {
        type: String,
        default: 'white',
        validator(value) {
          return ['white', 'default', 'primary', 'danger', 'success', 'warning', 'info'].includes(value);
        },
        description: 'Navbar type (primary|info|danger|default|warning|success)'
      },
      logo: String
    },
    components: {
      CollapseTransition
    },
    data() {
      return {
        displayNavbar: false
      }
    },
    computed: {
      classes() {
        let color = `bg-${this.type}`;
        let navPosition = `navbar-${this.position}`;
        return [
          {'navbar-transparent': !this.showNavbar && this.transparent},
          {[color]: this.showNavbar || !this.transparent},
          navPosition]
      }
    },
    methods: {
      onToggle(){
        this.$emit('update:showNavbar', !this.showNavbar);
      },
      hideNavbar() {
        this.$emit('update:showNavbar', false);
      }
    }
  }
</script>
<style scoped>
  .navbar-relative {
    position: relative;
  }
  .navbar.bg-white.navbar-absolute {
    box-shadow: 0px 3px 15px rgba(0,0,0,0.2);;
  }
</style>
